import { combineReducers } from '@reduxjs/toolkit';
import { GlobalRouter } from '@okapi/router-react';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { featuresReducer } from 'features';
import { Layers, initReducer } from './utils';
import { Env } from './types';

export const rootReducer = ({
  cookie,
  env,
  globalRouter,
  host,
  toErrorPage,
  layers,
  userAgent,
  isBot = false,
}: {
  cookie: string;
  env: Env;
  globalRouter: GlobalRouter;
  host: string | null;
  toErrorPage: string | string[];
  layers: Layers;
  userAgent: string | null;
  isBot?: boolean;
}) =>
  combineReducers({
    app: featuresReducer,
    cookie: initReducer(cookie),
    env: initReducer(env),
    host: initReducer(host),
    toErrorPage: initReducer(toErrorPage),
    layers: initReducer(layers),
    router: createRouterReducer(globalRouter),
    userAgent: initReducer(userAgent),
    isBot: initReducer(isBot),
  });

export type RootReducer = ReturnType<ReturnType<typeof rootReducer>>;
